exports.APPROVING_ROLE = 'feature:settings:facilities:approvals'
exports.CAN_PROPOSE_ROLE = 'feature:settings:facilities:changes'
exports.BY_EFFECTIVE_DATE_VIEW_NAME = 'by-effective-date'
exports.LOCATIONS_BY_COUNTRY_AND_EFFECTIVE_DATE_VIEW_NAME = 'locations-by-country-and-effective-date'
